// extracted by mini-css-extract-plugin
export default {"wrapper":"FourDigitInput_wrapper__SxIjb","input":"FourDigitInput_input__6HDFe"};